var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('player-embed-controler',{staticClass:"add-episode-player",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var playerEmbed = ref.playerEmbed;
var methods = ref.methods;
return [_c('add-episode-player-wrapper',{attrs:{"player-embed":playerEmbed,"initialize-embed":methods.initializeEmbed,"set-global-config":methods.setGlobalConfig,"set-embed-setting":methods.setEmbedSetting,"show":_vm.show}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }